module.exports = __webpack_public_path__ + "static/img/img_product_err_img.f41494c5.png";